/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityHostingAggEntry } from './MonitEntityHostingAggEntry';
import {
    MonitEntityHostingAggEntryFromJSON,
    MonitEntityHostingAggEntryFromJSONTyped,
    MonitEntityHostingAggEntryToJSON,
} from './MonitEntityHostingAggEntry';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityHostingAggResponse
 */
export interface MonitPaginatedEntityHostingAggResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHostingAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHostingAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHostingAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityHostingAggEntry>}
     * @memberof MonitPaginatedEntityHostingAggResponse
     */
    results?: Array<MonitEntityHostingAggEntry>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityHostingAggResponse interface.
 */
export function instanceOfMonitPaginatedEntityHostingAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityHostingAggResponseFromJSON(json: any): MonitPaginatedEntityHostingAggResponse {
    return MonitPaginatedEntityHostingAggResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityHostingAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityHostingAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityHostingAggEntryFromJSON)),
    };
}

export function MonitPaginatedEntityHostingAggResponseToJSON(value?: MonitPaginatedEntityHostingAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityHostingAggEntryToJSON)),
    };
}

